import React, { useState, useEffect, useContext } from "react"

import styled from "styled-components"
import { useLocation } from "react-router-dom"
import { RiRotateLockLine } from "react-icons/ri"
import { AiOutlineSetting } from "react-icons/ai"
import { BiWalletAlt } from "react-icons/bi"
import TopSellerFullView from "../components/TopSellerFullView"
import SimpleFormInput from "../components/SimpleFormInput"
import ToggleButton from "react-toggle-button"

import { ThemeContext } from "../context/ThemeContext"
import SimpleTextArea from "../components/SimpleTextArea"
import { db, useAuth } from "../firebase-config"
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  updateDoc,
  where,
  deleteDoc,
} from "firebase/firestore"
import PrimaryBtn from "../components/PrimaryBtn"
import { toast, ToastContainer } from "react-toastify"
import { getAuth } from "firebase/auth"
import CustomModal from "../components/CustomModal"

const Setting = () => {
  const location = useLocation()
  const currentUser = useAuth()
  const [toggleTab, setToggleTab] = useState(0)
  const [showFullView, setShowFullView] = useState(false)
  const [addAuction, setAddAuction] = useState(false)
  const [showWarnModal, setShowWarnModal] = useState(false)
  const [termsDetails, setTermsDetails] = useState(null)
  const [savePrg, setSavePrg] = useState("Save")
  const [deletePrg, setDeletePrg] = useState("Yes")
  const [userProfileDetails, setUserProfileDetails] = useState({})
  const [terms, setTerms] = useState({
    newsletter: false,
    articleLikeAlert: false,
    feedPersonalize: false,
    profileData: false,
  })

  const auth = getAuth()
  const [personalInfo, setPersonalInfo] = useState({
    name: "",
    dob: "",
    email: "",
    phone: "",
    gender: "",
    address: "",
    country: "",
    shopName: "",
  })

  const [bankDetails, setBankDetails] = useState({
    bankInfo: "",
    sponser: "",
  })

  const topSellerData = [
    {
      fullname: "Leslie Alexander",
    },
    {
      fullname: "ffsie Alexander",
    },
    {
      fullname: "Courtney Henry",
    },
    {
      fullname: "Sounst Henry",
    },
  ]

  const { theme } = useContext(ThemeContext)
  const [iconColor, setIconColor] = useState(
    theme === "light" ? "#19202A" : "#fff"
  )
  const colorToggle = () => {
    theme === "light" ? setIconColor("#19202A") : setIconColor("#fff")
  }

  const fetchProfileDetails = async () => {
    const profileRef = doc(db, "users", currentUser?.uid)
    const resp = await getDoc(profileRef)
    if (resp.exists()) {
      // console.log(resp.data())
      let personalInf = resp.data()
      setTermsDetails(personalInf.terms)
      setUserProfileDetails(resp.data())
    }
  }

  const handleToggleNewsletterChange = async () => {
    const profileRef = doc(db, "users", currentUser?.uid)
    console.log(!terms.newsletter)
    setTerms({ ...terms, newsletter: !terms.newsletter })
    // console.log(terms)
    // try {
    //   await updateDoc(profileRef, {
    //     terms,
    //   })
    //   console.log(terms)
    // } catch (error) {
    //   console.log(error)
    // }
  }
  const handleToggleArticleLikeChange = async () => {
    const profileRef = doc(db, "users", currentUser?.uid)

    setTerms({
      ...terms,
      articleLikeAlert: !terms.articleLikeAlert,
    })

    // try {
    //   await updateDoc(profileRef, {
    //     terms,
    //   })
    // } catch (error) {
    //   console.log(error)
    // }
  }
  const handleToggleFeedPersonalizeChange = async () => {
    const profileRef = doc(db, "users", currentUser?.uid)

    setTerms({
      ...terms,
      feedPersonalize: !terms.feedPersonalize,
    })
    console.log(terms)
    // try {
    //   await updateDoc(profileRef, {
    //     terms,
    //   })
    // } catch (error) {
    //   console.log(error)
    // }
  }

  const handleToggleProfileDataChange = async () => {
    const profileRef = doc(db, "users", currentUser?.uid)

    setTerms({ ...terms, profileData: !terms.profileData })

    try {
      await updateDoc(profileRef, {
        terms,
      })
    } catch (error) {
      console.log(error)
    }
  }

  const updateUserProfile = async () => {
    if (
      !personalInfo.name ||
      !personalInfo.email ||
      !personalInfo.address ||
      !personalInfo.country ||
      !personalInfo.dob ||
      !personalInfo.phone
    ) {
      toast.error("All Fields are Required", { autoClose: 2000 })
      return
    } else {
      try {
        personalInfo.shopName = userProfileDetails?.personalInfo?.shopName
          ? userProfileDetails?.personalInfo?.shopName
          : "NO Name"
        setSavePrg("Saving...")
        const profileRef = doc(db, "users", currentUser.uid)
        await updateDoc(profileRef, {
          personalInfo,
        })
        toast.success("Profile Updated")
        setSavePrg("Save")
      } catch (error) {
        setSavePrg("Save")
        console.log(error)
      }
    }
  }

  const updateBankDetails = async () => {
    if (!bankDetails.bankInfo || !bankDetails.sponser) {
      toast.error("Bank Detail is Required", { autoClose: 1000 })
      return
    } else {
      try {
        setSavePrg("Saving...")
        const profileRef = doc(db, "users", currentUser.uid)
        await updateDoc(profileRef, {
          bankDetails,
        })
        toast.success("Bank Details Updated")
        setSavePrg("Save")
      } catch (error) {
        setSavePrg("Save")
        console.log(error)
      }
    }
  }

  const deleteMyAccount = async () => {
    try {
      setDeletePrg("Deleting..")
      const productRef = collection(db, "products")
      const productQuery = query(
        productRef,
        where("shopId", "==", `shop/${currentUser.uid}`)
      )
      const querySnapshot = await getDocs(productQuery)
      querySnapshot.forEach(docs => {
        deleteDoc(doc(db, "products", docs.id))
      })
      deleteDoc(doc(db, "users", currentUser?.uid))
      toast.success("Account and its Data Deleted")
      auth.currentUser.delete()
      localStorage.removeItem("Auth Token")
      setShowWarnModal(false)
      setDeletePrg("Delete")
    } catch (error) {
      setDeletePrg("Delete")
      toast.error("Error occured while deleting")
      console.log(error)
    }
  }

  const ModalView = (
    <ModalWrap>
      <span>Are you Sure want to delete ? this action is ireversible!</span>

      <div className="applybtn_cont">
        <button className="applybtn" onClick={() => setShowWarnModal(false)}>
          Cancel
        </button>
        <button className="applybtn" onClick={deleteMyAccount}>
          {deletePrg}
        </button>
      </div>
    </ModalWrap>
  )

  useEffect(() => {
    if (currentUser?.uid && termsDetails !== null) {
      updateDoc(doc(db, "users", currentUser.uid), {
        terms,
      })
    }
  }, [terms])

  useEffect(() => {
    colorToggle()
  }, [theme])

  useEffect(() => {
    if (toggleTab === 3) {
      fetchProfileDetails()
    }
  }, [toggleTab])

  useEffect(() => {
    setTerms({
      newsletter: termsDetails?.newsletter,
      articleLikeAlert: termsDetails?.articleLikeAlert,
      feedPersonalize: termsDetails?.feedPersonalize,
      profileData: termsDetails?.profileData,
    })
    // console.log(termsDetails)
    // console.log(terms)
  }, [termsDetails])

  useEffect(() => {
    fetchProfileDetails()
  }, [currentUser?.uid])

  useEffect(() => {
    setPersonalInfo({
      name: userProfileDetails?.personalInfo?.name,
      dob: userProfileDetails?.personalInfo?.dob,
      email: userProfileDetails?.personalInfo?.email,
      phone: userProfileDetails?.personalInfo?.phone,
      gender: userProfileDetails?.personalInfo?.gender,
      address: userProfileDetails?.personalInfo?.address,
      country: userProfileDetails?.personalInfo?.country,
      shopName: userProfileDetails?.personalInfo?.shopName,
    })
  }, [userProfileDetails])

  return (
    <>
      {showWarnModal && <CustomModal>{ModalView}</CustomModal>}
      <ToastContainer limit={2} position={"top-center"} />
      <EventsScreenWrap>
        <VerticalTabBar>
          <AdminListArr>
            <Tabbtn
              onClick={() => setToggleTab(1)}
              className={toggleTab === 1 ? "active-tab" : ""}
            >
              <AiOutlineSetting
                style={{ marginRight: "10px" }}
                size={15}
                color={toggleTab === 1 ? "#fff" : iconColor}
              />
              Setting
            </Tabbtn>
            <Tabbtn
              onClick={() => setToggleTab(2)}
              className={toggleTab === 2 ? "active-tab" : ""}
            >
              <BiWalletAlt
                style={{ marginRight: "10px" }}
                size={18}
                color={toggleTab === 2 ? "#fff" : iconColor}
              />
              Wallet
            </Tabbtn>
            <Tabbtn
              onClick={() => setToggleTab(3)}
              className={toggleTab === 3 ? "active-tab" : ""}
            >
              <RiRotateLockLine
                style={{ marginRight: "10px" }}
                size={15}
                color={toggleTab === 3 ? "#fff" : iconColor}
              />
              Confidentiality
            </Tabbtn>
          </AdminListArr>
        </VerticalTabBar>
        {toggleTab === 1 ||
        location.hash.replace("%20", " ", "#", "").substring(1) ===
          "Setting" ? (
          <CardContainer>
            {!showFullView ? (
              <>
                <div className="pagetitle_cont">
                  <PageTitle>
                    {location.hash.replace("%20", " ").substring(1)}
                  </PageTitle>
                  {/* <AddEventBtn>Add Event</AddEventBtn> */}
                </div>
                <SimpleFormInput
                  defValue={userProfileDetails?.personalInfo?.name}
                  value={personalInfo.name}
                  handleOnChange={e =>
                    setPersonalInfo({ ...personalInfo, name: e.target.value })
                  }
                  btnLabel={"Edit"}
                  label={"Name*"}
                />
                <SimpleFormInput
                  defValue={userProfileDetails?.personalInfo?.email}
                  value={personalInfo.email}
                  handleOnChange={e =>
                    setPersonalInfo({ ...personalInfo, email: e.target.value })
                  }
                  btnLabel={"Edit"}
                  label={"Email*"}
                />
                <SimpleFormInput
                  defValue={userProfileDetails?.personalInfo?.phone}
                  value={personalInfo.phone}
                  handleOnChange={e =>
                    setPersonalInfo({ ...personalInfo, phone: e.target.value })
                  }
                  btnLabel={"Edit"}
                  label={"Phone*"}
                />
                <SimpleFormInput
                  defValue={userProfileDetails?.personalInfo?.dob}
                  value={personalInfo.dob}
                  type="date"
                  handleOnChange={e =>
                    setPersonalInfo({ ...personalInfo, dob: e.target.value })
                  }
                  btnLabel={"Edit"}
                  label={"Date of Birth*"}
                />
                <SimpleFormInput
                  defValue={userProfileDetails?.personalInfo?.gender}
                  value={personalInfo.gender}
                  handleOnChange={e =>
                    setPersonalInfo({ ...personalInfo, gender: e.target.value })
                  }
                  list="gender"
                  btnLabel={""}
                  label={"Gender*"}
                />
                <datalist id="gender">
                  <option value="Male" />
                  <option value="Female" />
                  <option value="Prefer Not to say" />
                </datalist>
                <SimpleTextArea
                  defValue={userProfileDetails?.personalInfo?.address}
                  value={personalInfo.address}
                  handleOnChange={e =>
                    setPersonalInfo({
                      ...personalInfo,
                      address: e.target.value,
                    })
                  }
                  btnLabel={"Edit"}
                  label={"Address*"}
                />
                <SimpleFormInput
                  defValue={userProfileDetails?.personalInfo?.country}
                  value={personalInfo.country}
                  handleOnChange={e =>
                    setPersonalInfo({
                      ...personalInfo,
                      country: e.target.value,
                    })
                  }
                  btnLabel={"Edit"}
                  label={"Country*"}
                />
                <InfoTitle>*required to be filled</InfoTitle>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <PrimaryBtn label={savePrg} handleBtn={updateUserProfile} />
                </div>
              </>
            ) : (
              <TopSellerFullView
                title={"Top Seller of the week"}
                btnLabel={"Edit"}
                btnLabelTwo={"Edit"}
                noOfGem={10}
                item={topSellerData}
              />
            )}
          </CardContainer>
        ) : null}

        {toggleTab === 2 ||
        location.hash.replace("%20", " ").substring(1) === "Wallet" ? (
          <AuctionContentWrap>
            {!addAuction && (
              <div className="pagetitle_cont">
                <PageTitle>
                  {location.hash.replace("%20", " ").substring(1)}
                </PageTitle>
              </div>
            )}
            <FormContainer>
              <SimpleTextArea
                value={bankDetails.bankInfo}
                handleOnChange={e =>
                  setBankDetails({ ...bankDetails, bankInfo: e.target.value })
                }
                label={"Bank information"}
                btnLabel={""}
              />
              <SimpleTextArea
                value={bankDetails.sponser}
                handleOnChange={e =>
                  setBankDetails({ ...bankDetails, sponser: e.target.value })
                }
                label={"Sponser Link"}
                btnLabel={""}
              />
              <PrimaryBtn label={savePrg} handleBtn={updateBankDetails} />
            </FormContainer>
          </AuctionContentWrap>
        ) : null}

        {toggleTab === 3 ||
        location.hash.replace("%20", " ").substring(1) === "Confidentiality" ? (
          <BlogWrap>
            <div className="pagetitle_cont">
              <PageTitle>
                {location.hash.replace("%20", " ").substring(1)}
              </PageTitle>
            </div>
            <ArticleCardContainer>
              <div className="title_container">
                <span>I want the newsletters.</span>
                <ToggleButton
                  value={terms.newsletter}
                  onToggle={handleToggleNewsletterChange}
                  inactiveLabel={""}
                  activeLabel={""}
                />
              </div>
              <div className="title_container">
                <span>
                  I allow sending notification when I like an article..
                </span>
                <ToggleButton
                  value={terms.articleLikeAlert}
                  onToggle={handleToggleArticleLikeChange}
                  inactiveLabel={""}
                  activeLabel={""}
                />
              </div>
              <div className="title_container">
                <span>I allow personalization of my news feed .</span>
                <ToggleButton
                  value={terms.feedPersonalize}
                  onToggle={handleToggleFeedPersonalizeChange}
                  inactiveLabel={""}
                  activeLabel={""}
                />
              </div>
              <div className="title_container">
                <span>
                  I allow Game2Coin to personalize my news feed and search
                  results by evaluating my preferences, settings, previous
                  purchases and use of the Game2Coin website and app.
                </span>
                <ToggleButton
                  value={terms.profileData}
                  onToggle={handleToggleProfileDataChange}
                  inactiveLabel={""}
                  activeLabel={""}
                />
              </div>
              <PrimaryBtn
                handleBtn={() => setShowWarnModal(true)}
                label={"Delete My Account"}
              />
            </ArticleCardContainer>
          </BlogWrap>
        ) : null}
      </EventsScreenWrap>
    </>
  )
}

export default Setting

const EventsScreenWrap = styled.div`
  display: flex;
  height: 80vh;

  @media screen and (max-width: 768px) {
    height: 100vh;
  }
`
const VerticalTabBar = styled.div`
  display: flex;
  position: sticky;
  flex-direction: column;
  align-items: center;
  height: 95vh;
  width: 20%;
  max-width: 20%;
  min-width: 20%;
  background: ${({ theme }) => theme.background};
  /* background: cyan; */
  @media screen and (max-width: 768px) {
    display: none;
  }

  .active-tab {
    background: #dc1d13;
    transition: 500ms;
    cursor: pointer;
    color: #fff;
  }
`
const AdminFormWrap = styled.div`
  display: flex;
  width: 100%;
  background: #fff;

  .infotip_label {
    position: absolute;
    bottom: -5rem;
    right: 1.5rem;
  }
`

const AdminListArr = styled.div`
  display: flex;
  flex-direction: column;
  height: 75vh;
  padding-top: 1.5rem;
  width: 100%;
  overflow-y: auto;

  /* @media screen and (max-width: 768px) {
   flex-direction: row;
  } */
`
const Tabbtn = styled.button`
  color: ${({ theme }) => theme.text};
  text-decoration: none;
  border: none;
  background: none;
  padding: 0.6rem 0rem;
  transition: 500ms;
  cursor: pointer;
  margin-bottom: 2rem;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 1.1rem;
  line-height: 29px;
  border-radius: 0px 5px 5px 0px;

  @media screen and (max-width: 768px) {
    color: ${({ theme }) => theme.text};
    font-size: 0.6rem;
  }
`
const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 1rem;
  /* height: 90vh; */
  overflow-y: auto;
  justify-content: space-around;
  .pagetitle_cont {
    display: flex;
    width: 100%;
    align-items: center;
  }

  ::-webkit-scrollbar {
    width: 0;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }

  ::-webkit-scrollbar-thumb {
    outline: 0 solid slategrey;
  }
`
const AddEventBtn = styled.button`
  cursor: pointer;
  background: var(--p-red);
  border: none;
  width: 10rem;
  color: #fff;
  float: right;
  height: 3rem;

  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
`
const AuctionContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1rem;
  align-items: center;

  .pagetitle_cont {
    display: flex;
    width: 100%;
    align-items: center;
  }

  .empty_image {
    width: 206px;
    height: 300px;
  }
`
const AuctionContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  .auctionDate {
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 1.5rem;
    color: #19202a;
  }

  .auctionTime {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 2rem;
    color: #19202a;
  }
`

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
const BlogWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1rem;
  align-items: center;

  .pagetitle_cont {
    display: flex;
    width: 100%;
    align-items: center;
  }
  .empty_image {
    width: 206px;
    height: 300px;
  }
`
const ArticleCardContainer = styled.div`
  display: flex;
  padding: 1rem;
  height: 90vh;
  width: 100%;
  flex-direction: column;
  .title_container {
    display: flex;
    width: 100%;
    height: fit-content;
    padding: 1rem 0;
    justify-content: space-between;
    align-items: center;
    span {
      font-family: Montserrat;
      font-style: normal;
      font-weight: 500;
      font-size: 1rem;
    }
  }
`

const PageTitle = styled.div`
  padding: 1rem;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.text};
`

const InfoTitle = styled.label`
  font-size: 0.8rem;
  float: right;
  font-family: Montserrat;
  font-style: normal;
  color: ${({ theme }) => theme.text};
`

const ModalWrap = styled.div`
  display: flex;
  flex-direction: column;

  label,
  span {
    font-size: 0.8rem;
    color: ${({ theme }) => theme.text};
  }

  select {
    margin-bottom: 0.5rem;
  }

  #price {
    border: none;
    outline: none;
    :focus {
      outline: none;
    }
  }

  .applybtn_cont {
    display: flex;
    align-items: center;
    padding: 0.5rem 0;
    justify-content: space-between;
  }

  .applybtn {
    border: none;
    outline: none;
    font-size: 0.8rem;
    background: ${({ theme }) => theme.accent};
    width: fit-content;
    padding: 0.5rem 0.8rem;
    cursor: pointer;
    color: ${({ theme }) => theme.text};
  }
`
